module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c(_vm.component, {
    tag: "Component",
    attrs: {
      "details": _vm.details,
      "areas": _vm.areas,
      "projects": _vm.projects
    },
    on: {
      "changeDetail": function($event) {
        return _vm.swapView($event)
      }
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c201a4de!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/ia/EmployeeViewSwap.vue
// module id = 1112
// module chunks = 0